import '../../assets/availableColumn.svg.mjs';
import availableColumnIcon__default from "../../../../assets/availableColumn.svg";
"use strict";
const emptyColumn = {
  id: "emptyColumn",
  productTitle: "",
  description: "commons.emptyColumn.description",
  image: {
    src: availableColumnIcon__default,
    width: 50,
    height: 50
  },
  v3Image: {
    src: availableColumnIcon__default,
    width: 50,
    height: 50
  },
  propertyValues: []
};
export { emptyColumn };
//# sourceMappingURL=emptyColumn.mjs.map
